<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="Cari?Cari.Unvan+' Ödeme İşle':'Ödeme İşle'"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
      width="40%">
    <el-alert
        style="margin-bottom:20px"
        v-if="Hareket"
        :title="Hareket.id+' NOLU HAREKETE ÖDEME ALIYORSUNUZ'"
        type="info">
    </el-alert>
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">
        <el-col :span="16" v-if="!Cari">
          <el-form-item label="Cari" prop="Cari_id">
            <el-select v-model="Form.Cari_id" filterable placeholder="Cari Seçiniz">
              <el-option
                  v-for="item in Cariler"
                  :key="item.id"
                  :label="item.Unvan"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <a class="formekstrebuton" @click="EkstreGetir(EkstreModal=true)" v-if="Form.Cari_id">Ekstre Görüntüle</a>
        </el-col>

        <el-col :span="8">
          <el-form-item label="Vade Tarihi" prop="vTarih">
            <el-date-picker
                autocomplete="off"
                v-model="Form.vTarih"
                type="date"
                format="dd.MM.yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="Cari?8:12">
          <el-form-item label="Tutar" prop="Tutar">
            <el-input type="text" v-model="Form.Tutar" @change="TutarKontrol" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="Cari?8:12">
          <el-form-item label="Kasa" prop="Kasa_id">
            <el-select v-model="Form.Kasa_id" clearable filterable placeholder="Kasa Seçiniz">
              <el-option
                  v-for="item in Kasalar"
                  :key="item.id"
                  :label="item.Adi"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Açıklama" prop="Aciklama">
            <el-input type="textarea" v-model="Form.Aciklama" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" class="text-center">
          <el-switch
              v-model="Form.Tur"
              active-text="Alınan Ödeme"
              inactive-text="Yapılan Ödeme">
          </el-switch>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button v-if="!lo" size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
    </div>

    <el-dialog
        v-if="EkstreModal"
        width="90%"
        title="Cari Ekstre"
        :visible.sync="EkstreModal"
        append-to-body>
<!--      <Detay :Cari_id="Form.Cari_id" v-if="Form.Cari_id" :Tur="true"></Detay>-->
    </el-dialog>
  </el-dialog>
</template>

<script>
// import Detay from "../Cari/Detay";

export default {
  // components: {Detay},
  props: ['Cari', 'Durum', 'Hareket'],
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      EkstreModal: false,
      Form: {
        Hizmet_id: null,
        Tur: true,
        Tutar: '',
        Aciklama: '',
        vTarih: '',
        Cari_id: null,
        Hareket_id: null
      },
      Cariler: null,
      Kasalar: null,
      FormHata: {
        Cari_id: [{required: true, message: "Cari Seçiniz", trigger: 'blur'}],
        Kasa_id: [{required: true, message: "Hizmet Seçiniz", trigger: 'blur'}],
        Tutar: [{required: true, message: "Tutar Giriniz", trigger: 'blur'}]
      },
    }
  },
  methods: {
    EkstreGetir() {

    },
    Kapat() {
      this.$emit('Durum')
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          this.$store.dispatch("Post", {...this.Form, path: 'hareket'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    },
    TutarKontrol() {

      if (this.Hareket) {
        if (this.Form.Tutar > this.Hareket.Tutar) {
          this.Form.Tutar = this.Hareket.Tutar
          this.$notify.error({
            title: "Ödenen tutar Hareket tutarından yüksek olamaz",
            customClass: 'error'
          });
        }
      }
    }
  },
  created() {
    if (this.Cari) this.Form.Cari_id = this.Cari.id
    if (this.Hareket) {
      this.Form.Tutar = this.Hareket.Tutar
      this.Form.Hareket_id = this.Hareket.id
    }
    this.$store.dispatch("Get", {path: 'cari/'})
        .then(response => {
          this.Cariler = response.Liste
        })
    this.$store.dispatch("Get", {path: 'kasa/'})
        .then(response => {
          this.Kasalar = response.Liste
        })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/Comp/OdemeIsle.vue